const residentsPages = {
  en: {
    patients: {
      title: 'Patients',
      createBtn: 'Create new patient',
      menuOptions: {
        printQR: 'Print QR-codes',
        downloadReport: 'Download report file',
      },
      searchInputPlaceholder: 'Search by patient name...',
      filters: {
        title: 'Filters',
        organizationTitle: 'Organizations',
        consentTitle: 'Consent',
        patientStatusTitle: 'Patient status',
        patientTypeTitle: 'Patient type',
        programsEnrolledTitle: 'Programs Enrolled',
        bhiStatusTitle: 'BHI status',
        psychiatryStatusTitle: 'Psychiatry status',
        ccmStatusTitle: 'CCM status',
        rpmStatusTitle: 'RPM status',
        guideStatusTitle: 'GUIDE status',
      },
      programsTitles: {
        guide: 'GUIDE',
        ccm: 'CCM',
        psychiatry: 'Psychiatry',
        bhi: 'BHI',
        rpm: 'RPM',
      },
      table: {
        patientHeader: 'Patients',
        locationHeader: 'Organization & location',
        consentHeader: 'Consent',
        programsParticipationsHeader: 'Programs participation',
      },
      addConsentBtn: 'Add Consent',
      tabs: {
        labels: {
          organizations: 'Organizations',
          allResidents: 'All patients',
        },
      },
      search: {
        placeholder: 'Start typing patient name...',
        tagName: 'By patient',
      },
      unknownOrg: 'Unknown Organization',
      printQrCodes: {
        title: 'Print QR-codes',
        selectType: 'Select type:',
        printQrCode: 'Print QR-code',
        pritnQrCodeInstructions: 'Print QR-code with instructions',
        printBtn: 'Print selected',
      },
      showMoreFiltersBtn: 'Show more filters ({count})',
    },
    createPatient: {
      title: 'Create new patient',
      buttons: {
        cancel: 'Cancel',
        create: 'Create',
      },
      messages: {
        patientCreated: 'Patient was created successfully',
      },
      duplicatesCard: {
        title: 'Warning!',
        subtitle: 'Possible duplicated patient',
        compareBtn: 'Compare',
        radioBtn: 'Mark as new',
      },
      duplicatesDialog: {
        title: '{names} might be a duplicate',
        subtitle: 'Please check if {names} are the same person.',
        currentPatient: 'Current',
        buttons: {
          cancel: 'No, they are different',
          submit: 'Yes, keep selected',
        },
        patientData: {
          preferredName: 'Preferred name',
          dob: 'Date of birth',
          middleName: 'Middle name',
          sex: 'Sex',
          optIn: 'Opt-in',
          contacts: 'Contacts',
          athenaId: 'Athena (EMR) ID',
          communityId: 'Location ID',
        },
      },
    },
    editResident: {
      title: 'Edit patient',
      buttons: {
        cancel: 'Cancel',
        update: 'Update and exit',
      },
      messages: {
        residentUpdated: 'Patient was successfully updated',
      },
    },
    residentForm: {
      validation: {
        requiredField: 'Required field',
      },
      mainInfo: {
        title: 'Main information',
        fields: {
          firstName: {
            label: 'Legal first name*',
            placeholder: 'Legal first name',
          },
          lastName: {
            label: 'Legal last name*',
            placeholder: 'Legal last name',
          },
          preferredName: {
            label: 'Preferred name',
            placeholder: 'Preferred name',
          },
          ssn: {
            label: 'Social security number (SSN)',
            placeholder: 'Social security number',
          },
          dob: {
            label: 'Date of birth',
          },
          sex: {
            label: 'Sex*',
          },
        },
        validation: {
          messages: {
            dob: 'The birth date entered is incorrect',
          },
        },
      },
      contactInfo: {
        title: 'Contact information',
        address: 'Address',
        fields: {
          mobilePhone: {
            label: 'Mobile phone number',
            placeholder: 'Mobile phone number',
          },
          homePhone: {
            label: 'Home phone number',
            placeholder: 'Home phone number',
          },
          email: {
            label: 'Email',
            placeholder: 'Email',
          },
          addressLine1: {
            label: 'Street address 1',
            placeholder: 'Street and number',
          },
          addressLine2: {
            label: 'Street address 2',
            placeholder: 'Street and number',
          },
          city: {
            label: 'City',
            placeholder: 'City',
          },
          zip: {
            label: 'ZIP code',
          },
          state: {
            label: 'State',
          },
        },
        validation: {
          messages: {
            mobilePhone: 'Phone must be valid',
            homePhone: 'Phone must be valid',
            email: 'Incorrect email',
          },
        },
      },
      additionalInfo: {
        title: 'Additional information',
        fields: {
          raceLegal: {
            label: 'Legal race',
            placeholder: 'Legal race',
            list: {
              americanIndian: 'American Indian',
              asian: 'Asian',
              black: 'Black',
              pacificIslander: 'Pacific Islander',
              white: 'White',
              other: 'Other',
              declined: 'Declined',
            },
          },
          ethnicity: {
            label: 'Ethnicity*',
            placeholder: 'Ethnicity',
            list: {
              hispanic: 'Hispanic',
              notHispanic: 'Not hispanic',
              unknown: 'Unknown',
              declined: 'Declined',
            },
          },
          primaryLanguage: {
            label: 'Primary language*',
            placeholder: 'Primary language',
            list: {
              english: 'English',
              spanish: 'Spanish',
              other: 'Other',
              unknown: 'Unknown',
            },
          },
          primaryLanguageDescription: {
            label: 'Description*',
            placeholder: 'Specify the language and other important data',
          },
          englishProficiency: {
            label: 'English proficiency*',
            placeholder: 'English level',
            list: {
              veryWell: 'Very well',
              well: 'Well',
              notWell: 'Not well',
              none: 'None',
              unknown: 'Unknown',
            },
          },
          residentType: {
            label: 'Patient type*',
            placeholder: 'Patient type',
          },
          organizationName: {
            label: 'Organization name*',
            placeholder: 'Organization name',
          },
          locationName: {
            label: 'Location name*',
            placeholder: 'Location name',
          },
          maritalStatus: {
            label: 'Marital status*',
            placeholder: 'Marital status',
            list: {
              married: 'Married',
              notMarried: 'Not Married',
              widowed: 'Widowed',
              separated: 'Separated',
              partner: 'Partner',
              divorced: 'Divorced',
              unknown: 'Unknown',
            },
          },
        },
        validation: {
          messages: {
            required: 'Required',
          },
        },
      },
    },
    residentProfile: {
      breadcrumbs: {
        residents: 'Patients',
      },
      messages: {
        consentDeleted: 'Consent was deleted',
      },
      mainData: {
        messages: {
          resyncSuccess: 'Resync was successful',
          deleteResidentFromCommunity: {
            success: 'The {residentName} has been successfully deleted from {communityName}',
            error: 'Something went wrong',
          },
          moveResident: {
            success: 'The {residentName} has been successfully moved to {communityName}',
            error: 'Something went wrong',
          },
        },
        tagList: {
          type: 'Type: {type}',
          notVerified: 'Not verified',
          movedOut: 'Moved out',
          consented: 'Consented',
          noConsent: 'No consent',
					isHospice: 'Hospice Patient'
        },
        dropdown: {
          resync: 'Resync',
          moveResident: 'Move patient',
          removeResident: 'Remove patient',
        },
        buttons: {
          moveResident: 'Move into a location',
        },
        content: {
          lastCommunity: 'The last location',
          dateMoveOut: 'Date move out',
          athenaId: 'Athena (EMR) ID',
        },
        removeResidentDialog: {
          validation: {
            required: 'Required',
          },
          title: {
            removeResident: 'Remove patient',
            deleteResident: 'Delete {residentName}',
          },
          descr: 'Are you sure you want to delete patient? You won’t be able to undo this action',
          fields: {
            movedOut: {
              label: 'Date move out*',
            },
          },
          buttons: {
            deleteResident: 'Delete patient',
            cancel: 'Cancel',
          },
        },
        communityListDialog: {
          title: 'Move into a location',
          fields: {
            organization: {
              label: 'Organization'
            },
            search: {
              placeholder: 'Start typing location name...',
            },
          },
          table: {
            columns: {
              communities: {
                label: 'Locations',
                title: 'Locations',
              },
            },
            search: {
              noResults: 'No results for “{search}”',
              clear: 'Clear results',
            },
          },
          buttons: {
            submit: 'Confirm',
          },
        },
        moveResidentDialog: {
          validation: {
            required: 'Required',
          },
          title: 'Add {residentName} to \n {communityName}',
          fields: {
            moveIn: {
              label: 'Move in Date*',
            },
          },
          buttons: {
            submit: 'Confirm',
          },
        },
      },
      notificationCard: {
        title: 'Notifications ({count})',
        commonType: {
          text: {
            newResidentAdded: 'New patient added',
            residentNotFound: 'Patient not found',
          },
        },
        awaitingType: {
          text: {
            possibleDuplicate: 'Possible duplicated patient',
            consentSubmitted: 'Consent submitted',
            insuranceAdded: 'Insurance Added',
          },
          buttons: {
            submit: 'Resolve',
          },
        },
      },
      documents: {
        consentCard: {
          title: 'Consent',
          buttons: {
            addNewConsent: 'Add new consent',
            addConsent: 'Add consent',
            printConsent: 'Print prefilled consent',
            updateConsent: 'Update consent',
          },
          table: {
            headings: {
              status: 'Status',
              signedBy: 'Signed by',
              dateUpload: 'Date upload',
            },
            content: {
              declined: 'Declined',
              by: 'by',
              signedBy: 'Signed by:',
              reSend: 'Re-send',
            },
          },
          messages: {
            cantPreviewConsent: `Can't preview the consent`,
            consentSentToEmail: `Consent was sent to {signerFullName}`,
          },
          addNewConsentDialog: {
            title: 'Are you sure you want to add new consent?',
            text: 'We already have obtained consent',
            buttons: {
              cancel: 'Cancel',
              submit: 'Add anyway',
            },
          },
          deleteConsentDialog: {
            title: 'Remove consent',
            text: 'Are you sure you want to delete consent? You won’t be able to undo this action',
            buttons: {
              cancel: 'Cancel',
              submit: 'Delete consent',
            },
          },
        },
        visitsCard: {
          title: 'Visits',
          noDocuments: 'No documents',
        },
      },
      personal: {
        messages: {
          updateSSN: {
            success: 'Social Security Number has been successfully updated',
            error: 'Something went wrong',
          },
          resyncPatient: {
            success: 'The location ID has been successfully resynced',
            error: 'Something went wrong',
          },
        },
        personalDataCard: {
          title: 'Personal data',
          buttons: {
            openQrCode: 'Open QR-code',
            edit: 'Edit',
          },
          columns: {
            preferredName: 'Preferred name',
            ssn: 'Social security number',
            update: 'Update',
            dob: 'Date of birth',
            sex: 'Sex',
            athenaId: 'Athena (EMR) ID',
            communityId: 'Location ID',
            resync: 'Resync',
            email: 'Email',
            homePhone: 'Home phone number',
            mobilePhone: 'Mobile phone number',
            address: 'Address',
          },
          ssnDialog: {
            title: 'Social Security Number',
            messages: {
              incorrectSsn: 'Incorrect social security number',
            },
            fields: {
              ssn: {
                label: 'Social Security Number (SSN)',
              },
            },
            buttons: {
              update: 'Update',
            },
          },
          qrCodeDialog: {
            title: 'QR-code',
            text: 'Scan QR-code to request Urgent Care Visit',
          },
        },
        insuranceCard: {
          title: 'Insurance',
          noInsuranceInfo: 'No Insurances Information Available',
          buttons: {
            addNewInsurance: 'Add new insurance',
          },
          insuranceStatus: {
            verified: 'Insurance Verified',
            declined: 'Insurance Declined',
            invalid: 'Insurance Invalid',
            submitted: 'Insurance Submitted',
            none: 'None',
          },
          columns: {
            policyHolder: 'Policy Holder',
            memberId: 'Member ID',
            healthPlan: 'Health Plan',
            status: 'Status',
          },
        },
        programsList: {
          title: 'Program Participation',
          optInStatus: 'Opt in status',
          guide: 'GUIDE',
          urgentCare: 'Urgent Care',
          rpm: 'RPM',
          ccm: 'CCM',
          psychiatry: 'Psychiatry',
          bhi: 'BHI',
          buttons: {
            edit: 'Edit',
          },
        },
        devicesCard: {
          title: 'Devices',
          noDevices: 'No devices currently added',
          buttons: {
            addNewDevice: 'Add new device',
          },
          deviceIdLabel: {
            assure: 'Please enter the device’s ID',
            wavve: 'Please enter the device’s serial number',
            glucose: 'Please enter the device’s ID',
            bloodPressure: 'Please enter the device’s IMEI',
            scale: 'Please enter the device’s IMEI',
            pulseOx: 'Please enter the device’s serial no.',
            kamiCare: 'Please enter the device’s DID',
            default: 'Please enter the device’s ID',
          },
          deviceIdPlaceholder: {
            assure: '26-alphanumeric device’s ID',
            wavve: '20-alphanumeric device’s S/N',
            bloodPressure: '15-digit IMEI',
            scale: '15-digit IMEI',
            pulseOx: '15-character serial no.',
            glucose: '7-character device’s ID',
            kamiCare: '20-character DID',
            default: 'Enter device’s ID',
          },
          validation: {
            required: 'Required',
            selectStatus: 'Select status',
            assure: 'Invalid device’s ID. Must be 26 alphanumeric characters',
            wavve: 'Invalid device’s S/N. Must be 20 alphanumeric characters',
            bloodPressure: 'Invalid IMEI. Must be 15 digits',
            scale: 'Invalid IMEI. Must be 15 digits',
            pulseOx: 'Invalid serial no. Must be 15 characters',
            glucose: 'Invalid device’s ID. Must be 7 characters',
            kamiCare: 'Invalid DID. Must be 20 characters',
          },
          messages: {
            deviceAdded: 'Device successfully added',
            deviceUpdated: 'Device status successfully updated',
            deviceDeleted: 'The device has been successfully deleted',
          },
          table: {
            headings: {
              name: 'Name',
              type: 'Type',
              id: 'ID',
              status: 'Status',
              actions: 'Actions',
            },
            content: {
              fields: {
                changeStatus: {
                  label: 'Change status to:',
                  placeholder: 'Select status',
                },
              },
              buttons: {
                edit: 'Edit',
                apply: 'Apply',
              },
            },
          },
          addDeviceDialog: {
            title: 'Add a new device',
            fields: {
              deviceName: {
                label: 'Device name',
                placeholder: 'Select a device name',
              },
            },
            buttons: {
              submit: 'Save device',
            },
          },
          deleteDeviceDialog: {
            title: 'Delete device',
            text: `This will completely remove this device from the patient chart and potentially any measurements taken by the device. If you want to keep the data, but note that the device no longer in use, select "Unassigned" from the status dropdown. Are you sure you want to delete the device from the patient's chart?`,
            buttons: {
              cancel: 'Cancel',
              submit: 'Delete device',
            },
          },
        },
      },
      medical: {
        tabList: {
          conditions: 'Medical conditions',
          medications: 'Medications',
          allergies: 'Allergies',
          directives: 'Advanced directives',
          observations: 'Observations',
        },
        medicalFilter: {
          show: 'Show',
        },
        sourceSystemFilter: {
          allDataSources: 'All data sources',
        },
        noMedicalData: {
          title: 'No data',
          text: `There is no {currentState} data, but you can find {secondaryState} {type} by switching from “{currentState}” at the left top corner`,
        },
        conditions: {
          noData: 'No conditions data',
          snomedCode: 'SNOMED code',
          onsetDate: 'Onset date',
          dataSource: 'Data source',
          recorderBy: 'Recorded by',
          recorderDate: 'Recorded date',
          abatementDate: 'Abatement date',
        },
        medications: {
          noData: 'No medication data',
          asNeeded: 'As Needed',
          strength: 'Strength',
          effectiveStartDate: 'Effective start date',
          effectiveEndDate: 'Effective end date',
          orderDate: 'Order date',
          orderBy: 'Order by',
          recordedDate: 'Recorded date',
          recordedBy: 'Recorded by',
          dataSource: 'Data source',
          dose: 'Dose',
          frequency: 'Frequency',
          dosageStartTime: 'Dosage start time (from)',
          dosageEndTime: 'Dosage end time (to)',
          directions: 'Directions',
        },
        allergies: {
          noData: 'No allergies data',
          reactionType: 'Reaction type',
          severity: 'Severity',
          reactionText: 'Reaction text',
          onsetDate: 'Onset date',
          resolvedDate: 'Resolved date',
          dataSource: 'Data source',
          recordedDate: 'Recorded date',
          recordedBy: 'Recorded by',
        },
        directives: {
          noData: 'No Advance directives data',
          type: 'Type',
          orderDate: 'Order date',
          orderedBy: 'Ordered by',
          discontinuedDate: 'Discontinued date',
          discontinuedBy: 'Discontinued by',
          dataSource: 'Data source',
        },
        observations: {
          filters: {
            title: 'Filters',
            measurement: 'Measurement',
            dataSource: 'Data source',
            showBtn: 'Show',
            hideBtn: 'Hide',
            granularity: {
              title: 'Data granularity:',
              zoom: 'Zoom:',
              daily: 'Daily',
              hourly: 'Hourly',
              minutes: 'Minutes',
            },
          },
          table: {
            title: 'Measurement table',
            headings: {
              type: 'Type',
              value: 'Value',
              recordedDate: 'Recorded date',
              recordedBy: 'Recorded by',
              dataSource: 'Data source',
            },
            noData: 'No observations data',
          },
          noData: {
            title: 'No observations for now',
            descr:
              'No vitals are currently being tracked. If any, they will appear here. In case of critical or abnormal behavior, you will be notified additionally via alerts and notifications.',
          },
        },
      },
      visits: {
        noData: 'No more data',
        table: {
          timeHeader: 'Time',
          typeHeader: 'Type',
          locationAndResidentHeader: 'Location & patient',
          statusHeader: 'Status',
          ctaHeader: '',
        },
      },
      contacts: {
        title: 'Contacts',
        noData: 'No contacts',
        editButton: 'Edit',
        closeEditMode: 'Close edit mode',
        inactive: '(Inactive)',
        tooltipList: {
          poa: 'This contact has a power of Attorney',
          guarantor: 'This contact is a guarantor',
          pp: 'This contact has been invited to Patient Portal',
        },
        columns: {
          phoneNumber: 'Phone number',
          homeNumber: 'Home number',
        },
        buttons: {
          addNewContact: 'Add new contact',
        },
        messages: {
          contactDeleted: {
            success: 'Contact was deleted',
            error: 'Something went wrong: {error}',
          },
          invitationSent: 'Invitations sent',
          invitationResent: 'Invitations resent',
          accessToPortalDisabled: 'Access to Patient Portal for {residentName} has been disabled',
        },
        deactivateContactDialog: {
          title: 'Are you sure you want to deactivate {residentName}?',
          text: 'You won’t be able recover it and user will lost his access to Patient Portal',
          buttons: {
            cancel: 'Cancel',
            submit: 'Deactivate',
          },
        },
        removeContactDialog: {
          title: 'Remove contact',
          text: 'Are you sure you want to delete contact? You won’t be able to undo this action',
          buttons: {
            cancel: 'Cancel',
            submit: 'Delete contact',
          },
        },
        patientPortalCard: {
          title: 'Patient portal',
          noData: 'No Data about connected users',
          buttons: {
            inviteToPP: 'Invite to Patient portal',
            resend: 'Resend',
            blockAccess: 'Block access',
          },
          invitePPDialog: {
            title: 'Send invite to Patient Portal',
            content: {
              note: 'Please note',
              shouldHave: 'For inviting they should have',
              email: 'email',
              and: 'and',
              poa: 'Power of Attorney',
              invited: 'Invited',
              cantInvited: `Can't be invited`,
              addInfo: 'Add info',
            },
            tooltipList: {
              poa: 'This contact has a power of Attorney',
              guarantor: 'This contact is a guarantor',
            },
            inviteReason: {
              noEmail: '(no email)',
              deactivated: '(deactivated)',
              noEmailAndPa: '(no email and PA)',
              noPoa: '(no Power of Attorney)',
            },
            buttons: {
              inviteToPP: 'Invite to Patient Portal',
            },
          },
        },
        careTeam: {
          title: 'Care team',
          addMemberButton: 'Add team member',
          editButton: 'Edit',
          closeEditMode: 'Close edit mode',
          noData: 'No care team members',
          addNewMemberButton: 'Add team member',
          dialog: {
            title: 'Care team',
            subtitle: 'Add a care team member',
            searchPlaceholder: 'Start typing name..',
            noResults: 'No results for ',
            clearResult: 'Clear Results',
            noMembers: 'Clear Results',
            selectLabel: 'Role',
            selectPlaceholder: 'Select the user’s role on the team',
            buttonCancel: 'Cancel',
            buttonAdd: 'Add',
            userColumnName: 'Users',
            emailColumnName: 'Email',
          },
        },
      },
      editPrograms: {
        title: 'Program Participation',
        buttons: {
          cancel: 'Cancel',
          submit: 'Save',
        },
        radioList: {
          optIn: 'Opt in status:',
          guide: 'GUIDE:',
          urgentCare: 'Urgent Care:',
          psychiatry: 'Psychiatry:',
          ccm: 'CCM:',
          bhi: 'BHI:',
          rpm: 'RPM:',
        },
        messages: {
          programsUpdated: 'Participation Programs was successfully updated',
        },
      },
      createInsurance: {
        title: 'Add insurance',
        buttons: {
          cancel: 'Cancel',
          submit: 'Done',
        },
        fields: {
          firstName: {
            label: 'Policy holder first name*',
            placeholder: 'Policy holder first name',
          },
          lastName: {
            label: 'Policy holder last name*',
            placeholder: 'Policy holder last name',
          },
          patientRelation: {
            label: `Patient's relation*`,
            placeholder: `Patient's relation`,
          },
          dob: {
            label: 'Policy holder date of birth*',
          },
          sex: {
            label: 'Sex*',
          },
          packageName: {
            label: 'Insurance package name*',
            placeholder: 'Package Name',
          },
          memberId: {
            label: 'Member ID*',
            placeholder: 'Member ID',
          },
          issuedDate: {
            label: 'Issued date*',
          },
          order: {
            label: 'Set as*',
          },
          isVerified: {
            label: 'Add this insurance as verified',
          },
        },
        images: {
          front: {
            title: 'Insurance card (front)',
            buttons: {
              add: 'Add Insurance front',
            },
          },
          back: {
            title: 'Insurance card (back)',
            buttons: {
              add: 'Add Insurance back',
            },
          },
        },
        validation: {
          required: 'Required',
          firstName: 'Policy holder does not match patient first name.',
          lastName: 'Policy holder does not match patient last name.',
          orderDeclared: 'This order is already declared',
        },
        messages: {
          cantSetOrder: 'Cannot set insurance order',
          insuranceCreated: 'Insurance has been successfully created',
          insuranceDeleted: 'Insurance has been successfully deleted',
          insuranceReplaced: 'Insurance has been successfully replaced',
        },
        replaceInsurancePopup: {
          title: 'Replace existing {msg} insurance with new insurance?',
          text: 'This patient already has a {msg} insurance. Do you want to delete the existing insurance to add this new one? If so, choose "Delete and add". Otherwise, choose "Cancel" and edit the existing insurance to not be {msg} if desired.',
          buttons: {
            submit: 'Delete and add',
          },
        },
      },
      editInsurance: {
        title: 'Edit insurance',
        activation: {
          deactivate: 'Deactivate',
          activate: 'Activate',
        },
        buttons: {
          cancel: 'Cancel',
          submit: 'Done',
        },
        fields: {
          firstName: {
            label: 'Policy holder first name*',
            placeholder: 'Policy holder',
          },
          lastName: {
            label: 'Policy holder last name*',
            placeholder: 'Policy holder',
          },
          patientRelation: {
            label: `Patient's relation*`,
            placeholder: `Patient's relation`,
          },
          dob: {
            label: 'Policy holder date of birth*',
          },
          sex: {
            label: 'Sex*',
          },
          packageName: {
            label: 'Insurance package name*',
            placeholder: 'Package name',
          },
          memberId: {
            label: 'Member ID*',
            placeholder: 'Member ID',
          },
          issuedDate: {
            label: 'Issued date',
          },
          order: {
            label: 'Set as',
          },
          isVerified: {
            label: 'Add this insurance as verified',
          },
        },
        images: {
          front: {
            title: 'Insurance card (front)',
          },
          back: {
            title: 'Insurance card (back)',
          },
        },
        validation: {
          required: 'Required',
          firstName: 'Policy holder does not match patient first name.',
          lastName: 'Policy holder does not match patient last name.',
          orderDeclared: 'This order is already declared',
        },
        messages: {
          cantSetOrder: 'Cannot set insurance order',
        },
        deleteInsuranceDialog: {
          title: 'Are you sure you want to delete this insurance?',
          text: 'This action can not be undone',
          buttons: {
            submit: 'Confirm',
          },
        },
      },
      createContact: {
        title: 'Create new contact',
        buttons: {
          cancel: 'Cancel',
          submit: 'Submit',
        },
        messages: {
          contactCreated: 'New contact {firstName} {lastName} was successfully created.',
        },
      },
      editContact: {
        title: 'Edit Contact',
        buttons: {
          cancel: 'Cancel',
          submit: 'Update',
        },
        messages: {
          contactUpdated: 'Contact {firstName} {lastName} was successfully updated.',
        },
      },
      contactForm: {
        fields: {
          firstName: {
            label: 'First name',
            placeholder: 'First name',
          },
          lastName: {
            label: 'Last name',
            placeholder: 'Last name',
          },
          email: {
            label: 'Email',
            placeholder: 'Email',
          },
          isAddPhoneNumber: {
            label: 'Add phone number',
          },
          mobilePhone: {
            label: 'Mobile phone',
          },
          homePhone: {
            label: 'Home phone',
          },
          workPhone: {
            label: 'Work phone number',
          },
          faxNumber: {
            label: 'Fax number',
          },
          isAddAddress: {
            label: 'Add address',
          },
          addressLine1: {
            label: 'Street Address 1',
            placeholder: 'Street Address',
          },
          addressLine2: {
            label: 'Street Address 2',
            placeholder: 'Street Address',
          },
          city: {
            label: 'City',
            placeholder: 'City',
          },
          state: {
            label: 'State',
            placeholder: 'Location',
          },
          zip: {
            label: 'Zip',
          },
          relationship: {
            label: 'Relationship to patient',
          },
          relationshipDescription: {
            placeholder: 'Description of the type (Wife, Doctor)',
          },
          poa: {
            label: 'Power of Attorney',
            description: 'Can make legal decisions for the patient',
          },
          guarantor: {
            label: 'Guarantor',
          },
          note: {
            label: 'Note',
            placeholder: 'Some notes about this contact',
          },
        },
      },
      contactPage: {
        inactive: '(Inactive)',
        breadcrumbs: {
          residents: 'Patients',
        },
        tooltipList: {
          poa: 'This contact has a power of Attorney',
          guarantor: 'This contact is a guarantor',
          pp: 'This contact has been invited to Patient Portal',
        },
        phoneNumbersInfo: {
          mobilePhone: 'Mobile phone',
          homePhone: 'Home phone',
          workPhone: 'Work phone',
          faxNumber: 'Fax number',
        },
        addressInfo: {
          addressLine1: 'Street 1',
          addressLine2: 'Street 2',
          city: 'City',
          state: 'State',
          zip: 'Zip',
        },
        additionalInfo: {
          title: 'Additional Information:',
          email: 'Email',
          note: 'Note:',
        },
        infoCard: {
          note: 'Please note',
          text: 'To invite a contact to patient portal they must have',
          poa: 'Power of Attorney',
          and: 'and an',
          email: 'email',
        },
        messages: {
          consentSent: 'Consent was sent to {firstName} {lastName}',
          contactStatus: 'Contact {firstName} {lastName} was successfully {statusText}.',
          inviteToPP: 'Invite to Patient Portal has been sent',
          contactDeleted: 'Contact was deleted',
          inviteToDCM: 'Contact invited to Dementia Care Management',
        },
        cardActions: {
          title: 'Available actions:',
          editContact: 'Edit contact',
          emailConsent: 'Email consent for signature',
          deactivateContact: 'Deactivate contact',
          deleteContact: 'Delete contact',
          resendInviteToPP: 'Resend invite to Patient Portal',
          sendInviteToPP: 'Send invite to Patient Portal',
          sendInviteToDCM: 'Invite to DCM',
          activateContact: 'Activate Contact',
        },
        removeContactDialog: {
          title: 'Remove contact',
          text: 'Are you sure you want to delete contact? You won’t be able to undo this action',
          buttons: {
            cancel: 'Cancel',
            submit: 'Delete contact',
          },
        },
      },
      createConsent: {
        title: 'Adding consent',
        subtitle: 'Please select a way of adding consent',
        declineLink: 'The patient decides to decline consent',
        cardList: {
          uploadConsent: {
            title: 'Upload an already signed consent.',
            btn: 'Upload',
          },
          signOnline: {
            title: 'Sign a consent in person.',
            btn: 'Sign Online',
          },
          verbalConsent: {
            title: 'Document verbal consent.',
            btn: 'Confirm Consent',
          },
          emailConsent: {
            title: 'Email consent for signature.',
            btn: 'Send Email',
          },
        },
        messages: {
          contactCreated: 'New contact {firstName} {lastName} was successfully created.',
        },
        declineConsentDialog: {
          title: 'Are you sure you want to decline?',
          text: 'The patient or contact can decline our services. They can later sign the consent if they change their mind.',
          buttons: {
            cancel: 'Cancel',
            submit: 'Yes, decline',
          },
        },
        sendEmailDialog: {
          title: 'Send consent to',
          noContacts: 'No contacts',
          userRole: {
            resident: 'Patient',
            contact: 'Contact',
          },
          messages: {
            consentSent: 'Consent was sent to {firstName} {lastName}',
          },
          buttons: {
            createContact: 'Create new contact',
            sendConsent: 'Send',
          },
        },
        createContactDialog: {
          title: 'Create contact',
          validation: {
            required: 'Required',
            incorrectEmail: 'Incorrect email',
            incorrectPhoneNumber: 'Incorrect phone number',
          },
          fields: {
            firstName: {
              label: 'First name',
              placeholder: 'First name',
            },
            lastName: {
              label: 'Last name',
              placeholder: 'Last name',
            },
            email: {
              label: 'Email',
              placeholder: 'Email',
            },
            isAddPhoneNumber: {
              label: 'Add Phone Numbers',
            },
            mobilePhone: {
              label: 'Mobile phone',
              placeholder: 'Mobile phone',
            },
            homePhone: {
              label: 'Home phone',
              placeholder: 'Home phone',
            },
            workPhone: {
              label: 'Work phone',
              placeholder: 'Work phone',
            },
            faxNumber: {
              label: 'Fax phone',
              placeholder: 'Fax phone',
            },
            relationshipType: {
              label: 'Relationship to patient',
              placeholder: 'Specify relationship',
            },
            relationshipDescription: {
              label: 'Relationship description',
              placeholder: 'Description on the type (Wife, Doctor)',
            },
            poa: {
              label: 'Power of Attorney',
              description: 'Can make legal decisions for the patient',
            },
          },
          buttons: {
            submit: 'Create contact',
          },
        },
        verbalConsentDialog: {
          title: 'Verbal consent',
          noContacts: 'No contacts',
          validation: {
            required: 'Required',
          },
          messages: {
            contactCreated: 'New contact {firstName} {lastName} was successfully created.',
          },
          fields: {
            personName: {
              label: 'Person who received verbal consent*',
              placeholder: 'Person who collected (Required)',
            },
            verbalConsentFrom: {
              label: 'Verbal consent from:',
            },
            consentSigner: {
              label: 'Patient',
            },
            contact: {
              label: 'Contact:',
              poa: 'This contact has a power of Attorney',
            },
            addContact: {
              label: 'Add Contact',
            },
            firstName: {
              label: 'First name*',
              placeholder: 'First name',
            },
            lastName: {
              label: 'Last name*',
              placeholder: 'Last name',
            },
            relationshipType: {
              label: 'Relationship to patient',
              placeholder: 'Specify relationship',
            },
            canGiveConsent: {
              label: 'Can give consent',
            },
          },
          buttons: {
            submit: 'Next',
          },
        },
      },
      whoIsSignedConsentCard: {
        title: 'Who is signing document?',
        fields: {
          resident: {
            label: 'Patient',
          },
          contact: {
            label: 'Contact',
            createNewContact: 'Create new contacts',
          },
          staff: {
            label: 'Facility Staff',
          },
          staffName: {
            label: 'Facility Staff Member Name',
          },
        },
      },
      consentOnline: {
        title: 'Adding consent',
        step: 'Step',
        resignDocument: 'Resign document',
        signDocument: 'Sign document',
        preview: 'Preview',
        note: 'Please check patient’s or contact’s signature before saving document. If there is no signature, the document will be rejected.',
        as: 'as',
        messages: {
          contactCreated: 'New contact {firstName} {lastName} was successfully created.',
          signatureInserted: 'Your signature was inserted, check it before saving',
          consentUploaded: 'Consent was uploaded',
          error: 'Something went wrong',
        },
        buttons: {
          cancel: 'Cancel',
          next: 'Next',
          submit: 'Save',
        },
      },
      uploadSigned: {
        title: 'Adding consent',
        note: 'Please check patient’s or contact’s signature before saving document. If there is no signature, the document will be rejected.',
        buttons: {
          cancel: 'Cancel',
          submit: 'Save',
        },
        messages: {
          cantGetUploadedConsent: `Sorry! We can't get your uploaded consent`,
          contactCreated: 'New contact {firstName} {lastName} was successfully created.',
          consentUploaded: 'Consent was uploaded',
        },
      },
      verbalConsent: {
        title: 'Verbal Consent',
        resignDocument: 'Resign document',
        signDocument: 'Sign document',
        preview: 'Preview',
        buttons: {
          cancel: 'Cancel',
          submit: 'Save',
        },
        messages: {
          signatureInserted: 'Your signature was inserted, check it before saving',
          consentUploaded: 'Consent was uploaded',
          error: 'Something went wrong',
        },
      },
      declineConsent: {
        title: 'Decline consent',
        buttons: {
          cancel: 'Cancel',
          submit: 'Save',
        },
        messages: {
          contactCreated: 'New contact {firstName} {lastName} was successfully created.',
          consentDeclined: 'Consent was declined',
        },
      },
    },
  },
}

export default residentsPages
